// utils
import { _id, _postTitles } from 'src/_mock/assets';
import { paramCase } from 'src/utils/change-case';

// ----------------------------------------------------------------------

const MOCK_ID = _id[ 1 ];

const MOCK_TITLE = _postTitles[ 2 ];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/kAYnYYdib0aQPNKZpgJT6J/%5BPreview%5D-Minimal-Web.v5.0.0?type=design&node-id=0%3A1&t=Al4jScQq97Aly0Mn-1',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
      // verify: `${ROOTS.AUTH}/classic/verify`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    register_user: `${ROOTS.DASHBOARD}/ezelogs-user/register-user`,
    vendor_user: `${ROOTS.DASHBOARD}/ezelogs-user/vendor-user`,
    role_and_permision: `${ROOTS.DASHBOARD}/role-and-permission`,
    add_role_and_permision: `${ROOTS.DASHBOARD}/role-and-permission/create-role-perission`,
    billing_and_invoice: `${ROOTS.DASHBOARD}/billing-and-invoice`,
    add_billing_and_invoice: `${ROOTS.DASHBOARD}/billing-and-invoice/create-billing-invoice`,
    products_packages_basic: `${ROOTS.DASHBOARD}/product-packages/basic-cost`,
    products_packages_feature: `${ROOTS.DASHBOARD}/product-packages/module-features`,
    products_packages_plans: `${ROOTS.DASHBOARD}/product-packages/plans`,
    create_new_user_admin_side: `${ROOTS.DASHBOARD}/admin-users/new-user`,
    admin_marketing: `${ROOTS.DASHBOARD}/admin-users/marketing`,
    others_marketing: `${ROOTS.DASHBOARD}/admin-users/others`,
    admin_all_users: `${ROOTS.DASHBOARD}/admin-users/all-admin-users`,
    admin_leads: `${ROOTS.DASHBOARD}/admin-users/leads`,
    admin_sales: `${ROOTS.DASHBOARD}/admin-users/sales`,
    admin_demo: `${ROOTS.DASHBOARD}/admin-users/demo`,
    admin_technical: `${ROOTS.DASHBOARD}/admin-users/technical`,
    //marketing mangement
    marketing_dashboard: `${ROOTS.DASHBOARD}/marketing-management/dashboard`,
    marketing_tools: `${ROOTS.DASHBOARD}/marketing-management/marketing-tools`,
    marketing_list: `${ROOTS.DASHBOARD}/marketing-management/list`,
    marketing_board: `${ROOTS.DASHBOARD}/marketing-management/boards`,
    marketing_timeline: `${ROOTS.DASHBOARD}/marketing-management/timeline`,

    support_ticket: `${ROOTS.DASHBOARD}/support-tickets`,
    product_user_news_letter: `${ROOTS.DASHBOARD}/product-updates/newsletter`,
    product_user_news_letter_create: `${ROOTS.DASHBOARD}/product-updates/newsletter/create-news-letter`,
    product_user_user_maintainance: `${ROOTS.DASHBOARD}/product-updates/maintainance`,
    product_user_user_maintainance_create: `${ROOTS.DASHBOARD}/product-updates/maintainance/create-maintainace`,
    product_user_offers: `${ROOTS.DASHBOARD}/product-updates/offers`,
    product_user_offers_create: `${ROOTS.DASHBOARD}/product-updates/offers/create-offers`,
    product_user_blogs: `${ROOTS.DASHBOARD}/product-updates/blogs`,
    product_user_blogs_create: `${ROOTS.DASHBOARD}/product-updates/blogs/create-blogs`,
    product_user_general: `${ROOTS.DASHBOARD}/product-updates/general`,
    product_user_general_create: `${ROOTS.DASHBOARD}/product-updates/general/create-general`,
    product_features: `${ROOTS.DASHBOARD}/product-updates/product-features`,
    product_features_create: `${ROOTS.DASHBOARD}/product-updates/product-features/create-product-features`,

    technical_cost_codes: `${ROOTS.DASHBOARD}/technical-database/cost-codes`,
    technical_materials: `${ROOTS.DASHBOARD}/technical-database/material`,
    technical_equipments: `${ROOTS.DASHBOARD}/technical-database/equipments`,
    technical_trades: `${ROOTS.DASHBOARD}/technical-database/trades`,
    technical_trades_work_title: `${ROOTS.DASHBOARD}/technical-database/trades-work-title`,
    technical_bids: `${ROOTS.DASHBOARD}/technical-database/bids`,
    technical_stt_folders: `${ROOTS.DASHBOARD}/technical-database/stt-folders`,
    technical_stt_folders_show: `${ROOTS.DASHBOARD}/technical-database/stt-folders/stt-folders-show-page`,
    HomePage: `${ROOTS.DASHBOARD}/cms-management/website-pages`,
    Assests: `${ROOTS.DASHBOARD}/cms-management/assests`,

    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },

    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      edit: (title) => `${ROOTS.DASHBOARD} /post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
  },
};
